// extracted by mini-css-extract-plugin
module.exports = {"container":"aside_filters-module__container--2XulQ"};